<ion-header class="ion-no-border">
  <ion-toolbar class="Recovery-trac-header Recovery-trac-header1">
    <ion-title>LOCATION PERMISSIONS</ion-title>
    <span  (click)="closePage()" class="close_icon">
      <ion-icon size="large" name="close-outline"></ion-icon>
    </span>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="location-access">

    <ion-row class="location-icon">
      <ion-col><img id="location7" src="/assets/custom-icons/gps-location.png" alt="GPS Icon"/></ion-col>
    </ion-row>

    <ion-row class="location-title">
      <ion-col>Location Permissions Required</ion-col>
    </ion-row>

    <ion-row class="pa30 classContent">
      <div class="location-reason">
        This app uses location data to capture coordinates for forms and to report the position of clocked-in users even when the app is closed or not in use.
        You will not be able to log in without allowing location services.
      </div>

      <div class="location-instructions">
        <span *ngIf="platform === 'android'">
          <span *ngIf="osMajorVersion >= 12">
            <span *ngIf="gpsPermission === 'prompt' || gpsPermission === 'prompt-with-rationale'">
              Please tap the button below to enable location permissions. When prompted to choose between "Precise" and "Approximate," select "Precise."
            </span>
            <span *ngIf="gpsPermission === 'denied'">
              Please follow the instructions below to enable location permissions:
              <ol type="1">
                <li>Open your phone's Settings app</li>
                <li>Navigate to Apps > RecoveryTrac Flex > Permissions > Location</li>
                <li>Tap "Allow only while using the app"</li>
                <li>Ensure "Use precise location" is enabled</li>
              </ol>
            </span>
          </span>
          <span *ngIf="osMajorVersion < 12">
            <span *ngIf="gpsPermission === 'prompt' || gpsPermission === 'prompt-with-rationale'">
              Please tap the button below to enable location permissions. When prompted, choose "Allow."
            </span>
            <span *ngIf="gpsPermission === 'denied'">
              Please follow the instructions below to enable location permissions:
              <ol type="1">
                <li>Go to your phone's Settings app</li>
                <li>Navigate to Apps > RecoveryTrac Flex > Permissions > Location</li>
                <li>Tap "Allow"</li>
              </ol>
            </span>
          </span>
        </span>

        <span *ngIf="platform === 'ios'">
          <span *ngIf="gpsPermission === 'prompt' || gpsPermission === 'prompt-with-rationale'">
            Please tap the button below to enable location permissions. When prompted, choose "Allow While Using App."
          </span>
          <span *ngIf="gpsPermission === 'denied'">
            Please follow the instructions below to enable location permissions:
            <ol type="1">
              <li>Go to your phone's Settings app</li>
              <li>Navigate to Apps > RecoveryTrac Flex > Location</li>
              <li>Tap "While Using the App"</li>
              <li>Ensure "Precise Location" is enabled</li>
            </ol>
          </span>
        </span>

        <span *ngIf="platform === 'web'">
          <span *ngIf="browserName === 'chrome' || browserName === 'edge'">
            <span *ngIf="gpsPermission === 'prompt' || gpsPermission === 'prompt-with-rationale'">
              Please tap the button below to enable location permissions. When prompted, choose "Allow."
            </span>
            <span *ngIf="gpsPermission === 'denied'">
              Please follow the instructions below to enable location permissions:
              <ol type="1">
                <li>In the address bar, click the lock icon (🔒) to the left of this page's URL</li>
                <li>Under Permissions, click the dropdown next to Location and choose "Allow"</li>
              </ol>
            </span>
          </span>
          <span *ngIf="browserName === 'firefox'">
            <span *ngIf="os !== 'android' && os !== 'ios'">
              <span *ngIf="gpsPermission === 'prompt' || gpsPermission === 'prompt-with-rationale'">
                Please tap the button below to enable location permissions. When prompted, check the "Remember this decision" box and choose "Allow."
              </span>
              <span *ngIf="gpsPermission === 'denied'">
                Please follow the instructions below to enable location permissions:
                <ol type="1">
                  <li>In the address bar, click the icon to the left of this page's URL</li>
                  <li>Next to "Access your location," click the "Blocked" tag</li>
                </ol>
              </span>
            </span>
            <span *ngIf="os === 'android' || os === 'ios'">
              <span *ngIf="gpsPermission === 'prompt' || gpsPermission === 'prompt-with-rationale'">
                Please tap the button below to enable location permissions. When prompted, check the "Remember this decision" box and choose "Allow."
              </span>
              <span *ngIf="gpsPermission === 'denied'">
                Please follow the instructions below to enable location permissions:
                <ol type="1">
                  <li>In the address bar, tap the lock icon (🔒) to the left of this page's URL</li>
                  <li>Change the Location permission to "Allowed"</li>
                </ol>
              </span>
            </span>
          </span>
          <span *ngIf="browserName === 'safari'">
            <span *ngIf="os === 'mac'">
              Please follow the instructions below to enable location permissions:
              <ol type="1">
                <li>Right-click the address bar</li>
                <li>Click "Settings for flex.recoverytrac.com"</li>
                <li>Change the Location setting to "Allow"</li>
              </ol>
            </span>
            <span *ngIf="os === 'ios'">
              Please follow the instructions below to enable location permissions:
              <ol type="1">
                <li>In the address bar, tap the "aA" to the left of this page's URL</li>
                <li>Tap "Website Settings"</li>
                <li>Change the Location setting to "Allow"</li>
                <li>Refresh the page</li>
              </ol>
            </span>
          </span>
          <span *ngIf="browserName === 'other'">
              Please tap the button below to enable location permissions. When prompted, choose "Allow."
              If you do not see a popup to enable permissions, you may need to enable them through your browser's settings.
          </span>
        </span>

      </div>
    </ion-row>
  </ion-grid>

  <app-footer-buttons-spacer></app-footer-buttons-spacer>
</ion-content>

<app-footer-buttons
  [rightButton]="{
    text: 'Continue'
  }"
  (rightButtonClicked)="turnOnGPS()"
></app-footer-buttons>
